export type PriorityCampaignModel = {
  cache_key: number,
  id: number,
  campaign_id: number,
  owner_id: number,
  owner_type: string,
  user_id?: number,
}

export type PriorityCampaignRequestOptions = {}

const state = {
  id: null,
  campaign_id: null,
  owner_id: null,
  owner_type: '',
}

export const requiredFields = [
  { key: 'campaign_id' },
  { key: 'owner_id' },
  { key: 'owner_type' },
]

export default state
